var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card w-100"},[_c('div',{staticClass:"card-header text-center"},[_vm._t("stat-name")],2),_c('div',{staticClass:"card-body text-center"},[_vm._t("stat-value")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }